// extracted by mini-css-extract-plugin
export var headerXL = "BlogTopPicks-module--headerXL--3Z3pc";
export var headerL = "BlogTopPicks-module--headerL--2aCOA";
export var headerM = "BlogTopPicks-module--headerM--29a4J";
export var headerS = "BlogTopPicks-module--headerS--1lojP";
export var headerXS = "BlogTopPicks-module--headerXS--10XmS";
export var blogHeaderXL = "BlogTopPicks-module--blogHeaderXL--3TBeR";
export var blogHeaderL = "BlogTopPicks-module--blogHeaderL--Bm_Nv";
export var blogHeaderM = "BlogTopPicks-module--blogHeaderM--25hMo";
export var blogHeaderS = "BlogTopPicks-module--blogHeaderS--30fQB";
export var blogHeaderXS = "BlogTopPicks-module--blogHeaderXS--29MMc";
export var headerPreamble = "BlogTopPicks-module--headerPreamble--3Wtqb";
export var preHeader = "BlogTopPicks-module--preHeader--1qF_w";
export var textNormal = "BlogTopPicks-module--textNormal--3oYED";
export var textSmall = "BlogTopPicks-module--textSmall--1hdCq";
export var textSmallAlternate = "BlogTopPicks-module--textSmallAlternate--2GPFr";
export var legend = "BlogTopPicks-module--legend--H3gn0";
export var caption = "BlogTopPicks-module--caption--3-aHn";
export var gradientBackground = "BlogTopPicks-module--gradientBackground--37vIn";
export var ellipsis = "BlogTopPicks-module--ellipsis--2uglT";
export var globalContainer = "BlogTopPicks-module--globalContainer--O18EX";
export var maxWidth = "BlogTopPicks-module--maxWidth--2wifF";
export var clipBottom = "BlogTopPicks-module--clipBottom--3UmBB";
export var clipTopBottom = "BlogTopPicks-module--clipTopBottom--3pI0h";
export var topPicks = "BlogTopPicks-module--topPicks--ku5i7";
export var container = "BlogTopPicks-module--container--1wW7x";
export var label = "BlogTopPicks-module--label--2AKdL";
export var content = "BlogTopPicks-module--content--2M95A";
export var ch2 = "BlogTopPicks-module--ch2--24X5y";
export var ch2Container = "BlogTopPicks-module--ch2-container--EQU0s";